import "./BorderButton.scss";

const BorderButton = ({ text, onClick }) => {
  return (
    <button className="borderButton" onClick={onClick}>
      {text}
    </button>
  );
};

export default BorderButton;
